import { render, staticRenderFns } from "./dniCheckbox.vue?vue&type=template&id=f961d3a0&"
import script from "./dniCheckbox.vue?vue&type=script&lang=js&"
export * from "./dniCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./dniCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports